module.exports = __webpack_public_path__ + "static/img/logo.35f777f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/radishImg/logo.png
// module id = FWjT
// module chunks = 1